import styled from 'styled-components';

export const FormContainer = styled('div')`
  min-height: 238px;
`;
